import moment from "moment";
import useInsightsApi from "PFCore/helpers/use_insights_api";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useEffect, useState } from "react";

import { useFlattenedAvailabilityFilters } from "../../../utils/use_flattened_availability_filters";
import { DateGranularity } from "../../common/date_granularity_selector";
import BudgetVsForecast from "./charts/budget_vs_forecast";

type DemandData = {
  booked_hours: number;
  requested_hours: number;
  date: string;
};

const DemandSection = () => {
  const { insightsApi, insightsApiError } = useInsightsApi();
  const { formatISODate } = useDateFormatter();

  const defaultFilters = {
    availability: {
      start: formatISODate(),
      end: formatISODate(moment().add(3, "months"))
    }
  };
  const [data, setData] = useState<DemandData[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [dateGranularity, setDateGranularity] = useState(DateGranularity.daily);
  const flattendedFilters = useFlattenedAvailabilityFilters(defaultFilters);

  useEffect(() => {
    setLoading(true);
    insightsApi("/booking_module_demand_requested_booked", {
      date_granularity: dateGranularity,
      ...flattendedFilters
    }).then((res) => {
      setLoading(false);
      setData(res["demand_requested_booked_graph"]);
    });
  }, [dateGranularity]);

  return (
    <BudgetVsForecast
      dateGranularity={dateGranularity}
      setDateGranularity={setDateGranularity}
      loading={loading}
      data={data}
      error={insightsApiError}
    />
  );
};

export default DemandSection;
